import React from 'react';
import { Navigate } from 'react-router-dom';

import { useSelector } from '../../redux/hooks';
import { selectUserProfile } from '../../redux/actions/users';

type PropsType = {
    children: React.ReactNode
};

export default function Carrier({ children }: PropsType) {
    const userProfile = useSelector(selectUserProfile());

    if (userProfile?.isCarrier === false) {
        return <Navigate to="/" replace />;
    }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{ children }</>;
}
